// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__L4YEu","empty":"style_empty__j16rJ","add_new_card":"style_add_new_card__GOfHQ"};